module.exports = __webpack_public_path__ + "img/fa-regular-400.89ffa3ab.svg";